module.exports = __webpack_public_path__ + "assets/2d0b894c12a22a0d58133569c0e719c0.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/drop/0/Drop_Wild.mp3
 ** module id = 205
 ** module chunks = 0
 **/